<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>跟进预览</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick()"
      >
        <!-- <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>-->

        <!-- <el-form-item label="状态">
          <el-select v-model="query.state" clearable placeholder="请选择状态" @change="typeClick()">
            <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="来源">
          <el-select v-model="query.origin" clearable placeholder="请选择来源" @change="typeClick()">
            <el-option
              v-for="item in originlist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item label="跟进时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker
            v-model="query.month"
            @change="selClick()"
            value-format="yyyy-MM"
            type="month"
          ></el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="地区">
          <el-cascader
            :options="areaList"
            v-model="query.selectedOptions"
            style="width:100%;"
            clearable
            filterable
            @change="typeClick()"
          ></el-cascader>
        </el-form-item>-->

        <el-form-item>
          <el-button type="primary" @click="selClick();">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表卡片 -->
    <div class="content">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-card class="box-card table">
            <div class="clearfix" slot="header">
              <span>日汇总</span>
            </div>
            <!-- 列表 -->
            <div>
              <el-table
                v-loading="loading"
                :data="tableData"
                ref="tableData"
                border
                stripe
                style="width:100%"
              >
                <el-table-column prop="day" label="日期"></el-table-column>
                <el-table-column prop="count" label="跟进总数"></el-table-column>
                <el-table-column prop="handleCount" label="待处理"></el-table-column>
                <el-table-column prop="preCount" label="预回访"></el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-tooltip content="查看跟进" placement="top">
                        <el-button
                          type="success"
                          size="mini"
                          icon="el-icon-view"
                          @click="viewClick(scope.row.day,1)"
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip content="查看预回访" placement="top">
                        <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-view"
                          @click="viewClick(scope.row.day,2)"
                        ></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card table">
            <div class="clearfix" slot="header">
              <span>日汇总</span>
            </div>
            <!-- 列表 -->
            <div>
              <el-table
                v-loading="loading2"
                :data="tableData2"
                ref="tableData2"
                border
                stripe
                style="width:100%"
              >
                <el-table-column prop="cusName" label="昵称"></el-table-column>
                <el-table-column prop="wechat" label="微信"></el-table-column>
                <el-table-column prop="title" label="跟进主题"></el-table-column>
                <el-table-column label="跟进状态">
                  <template slot-scope="scope">
                    <el-tag type="primary" v-if="scope.row.state==1">{{scope.row.stateName}}</el-tag>
                    <el-tag type="info" v-else-if="scope.row.state==2">{{scope.row.stateName}}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    var now = new Date();
    return {
      domain: url.getDomain(),
      customid: "",
      query: {
        month: now.getFullYear() + "-" + (now.getMonth() + 1),
      },
      form: {},
      dialogVisible: false, //对话框显示
      submiting: false, //表单提交
      loading: false, //列表加载
      tableData: [],
      loading2: false,
      tableData2: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      typelist: [
        { id: 1, name: "客户" },
        { id: 2, name: "合作方" },
      ], //类型
      statelist: [], //状态
      originlist: [], //来源
      areaList: [], //地区
      selectedOptions: [],
      companylist: [], //关联公司
    };
  },
  methods: {
    // 来源
    getOriginList: function () {
      var _this = this;
      var link = url.getCrm("getorigin");
      $.get(link, {}, (data) => {
        _this.originlist = data;
      });
    },
    // 状态
    getStateList: function () {
      var _this = this;
      if (this.$route.params.state) {
        var state = this.$route.params.state;
        this.query.state = parseInt(state);
      } else {
        this.query.state = null;
      }
      var link = url.getCrm("getcustomerstate");
      $.get(link, {}, (data) => {
        _this.statelist = data;
      });
    },
    // 地区
    getAreaList: function () {
      var _this = this;
      var link = url.getCommon("getcity");
      $.get(link, {}, (data) => {
        _this.areaList = data;
      });
    },
    // 关联公司
    getCompanyList: function () {
      var _this = this;
      var link = url.getAccInfo("getall_commany");
      $.get(link, {}, (data) => {
        _this.companylist = data;
      });
    },
    // 列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = this.query;
      var link = url.getCrm("GetCount_Month");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data;
      });
    },
    // 查询
    selClick: function () {
      this.pageIndex = 1;
      this.getList();
    },
    // 条件查询
    viewClick: function (date, type) {
      var _this = this;
      _this.loading2 = true;
      var link = url.getCrm("GetDetail_Day");
      $.get(link, { date: date, type: type }, (data) => {
        _this.loading2 = false;
        _this.tableData2 = data;
      });
    },
  },
  //监听路由变化
  watch: {},
  mounted() {
    //   列表
    this.getList();
  },
};
</script>